import { functions } from "@/services/functions";
import { httpsCallable } from "firebase/functions";

export const httpsCallables = {
  updateUserClaims: (
    userId: string,
    isAdmin?: boolean,
    userTenantId?: string,
    joinCode?: string
  ) => {
    const callable = httpsCallable(functions, "updateUserClaims");
    return callable({ userId, isAdmin, userTenantId, joinCode });
  },
};
